module.exports = __webpack_public_path__ + "static/img/h6-4.d543264.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd101/h6-4.png
// module id = rMpw
// module chunks = 1